import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Menu, X } from 'lucide-react';
import LanguageSelector from 'src/components/layout/LanguageSelector';
import LandingMark from 'src/components/layout/LandingMark';
import { useLocale } from 'src/contexts/LocaleContext';

function MarketingHeader({
  showLanguage = true,
  showBeta = true,
  active = null,
  anchorPrefix = '',
}) {
  const { t } = useLocale();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  const links = [
    { href: `${anchorPrefix}#features`, label: t('landing.navFeatures'), key: 'features' },
    { href: `${anchorPrefix}#pricing`, label: t('landing.navPricing'), key: 'pricing' },
    { href: '/blog', label: t('landing.navBlog'), key: 'blog' },
    { href: `${anchorPrefix}#contact`, label: t('landing.navContact'), key: 'contact' },
  ];

  return (
    <header className="border-b border-[#ede9fe] bg-white">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between px-5 py-5 sm:px-10 lg:px-20">
        <div className="flex items-center gap-1.5">
          <Link to="/" aria-label="ÁgilOdonto">
            <LandingMark />
          </Link>
          {showBeta && (
            <span className="rounded-md bg-[#f5f3ff] px-1.5 py-0.5 text-[10px] font-bold text-[#7c3aed]">
              {t('landing.beta')}
            </span>
          )}
        </div>

        <nav className="hidden items-center gap-6 md:flex">
          {links.map((item) => (
            <a
              key={item.key}
              href={item.href}
              aria-current={active === item.key ? 'page' : undefined}
              className={`text-sm font-medium hover:text-[#7c3aed] ${
                active === item.key ? 'text-[#7c3aed]' : 'text-[#4b5563]'
              }`}
            >
              {item.label}
            </a>
          ))}
          {showLanguage && <LanguageSelector />}
          <Link to="/login" className="inline-flex items-center gap-1 text-sm font-semibold text-[#7c3aed]">
            {t('landing.login')}
            <ArrowRight className="size-3.5" aria-hidden="true" />
          </Link>
        </nav>

        <button
          type="button"
          className="text-[#4b5563] md:hidden"
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? t('landing.closeMenu') : t('landing.openMenu')}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          {isMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </button>
      </div>

      {isMenuOpen && (
        <div className="space-y-1 border-t border-[#ede9fe] px-5 py-3 md:hidden">
          {links.map((item) => (
            <a
              key={item.key}
              href={item.href}
              onClick={closeMenu}
              aria-current={active === item.key ? 'page' : undefined}
              className="block rounded-lg px-3 py-2 text-sm font-medium text-[#4b5563] hover:bg-[#f5f3ff] hover:text-[#7c3aed]"
            >
              {item.label}
            </a>
          ))}
          {showLanguage && (
            <div className="px-3 py-2">
              <LanguageSelector />
            </div>
          )}
          <Link
            to="/login"
            onClick={closeMenu}
            className="flex items-center gap-1 rounded-lg px-3 py-2 text-sm font-semibold text-[#7c3aed]"
          >
            {t('landing.login')}
            <ArrowRight className="size-3.5" aria-hidden="true" />
          </Link>
        </div>
      )}
    </header>
  );
}

export default MarketingHeader;
